import {EDeviceType} from 'coreClasses/device/IDevice';

import {ECarouselDirection, ICarouselProps} from 'brandComponents/Carousel';

const PRODUCT_TILE_CAROUSEL_CONFIG = {
	DEFAULT: {
		loop: true,
		direction: ECarouselDirection.HORIZONTAL,
		slidesPerView: 1,
		navigationConfig: {
			enabled: true,
			prevBtnIcon: 'arrow-left',
			nextBtnIcon: 'arrow-right',
		},
		paginationConfig:{
			el: '.swiper-pagination-custom',
			enabled: true,
			renderBullet: function(_, className) {
				return `<span class=" ${className} "></span>`;
			}
		},
		mousewheel: false,
		duplicateSlides: {
			enabled: false,
			slidesNumber: 0,
		}
	},
};

export const getProductTileCarouselConfig = (device: EDeviceType, config?: Partial<ICarouselProps['config']>) => {
	let productTileCarouselConfig = {};

	if (PRODUCT_TILE_CAROUSEL_CONFIG.hasOwnProperty(device)) {
		productTileCarouselConfig = PRODUCT_TILE_CAROUSEL_CONFIG[device];
	}

	if (config) {
		productTileCarouselConfig = config;
	}

	return Object.assign({}, PRODUCT_TILE_CAROUSEL_CONFIG.DEFAULT, productTileCarouselConfig);
};
